import styled from 'styled-components';
import { motion } from 'framer-motion';


export const ProjectsContainer = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
`;

export const ProjectsHero = styled(motion.div)`
  height: 90vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, rgba(0,0,0,0.8), rgba(0,0,0,0.4));
    z-index: 1;
  }

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const HeroContent = styled(motion.div)`
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  padding: 0 2rem;

  h1 {
    font-size: 4.5rem;
    font-weight: 300;
    margin-bottom: 1.5rem;
    letter-spacing: 2px;
  }

  p {
    font-size: 1.5rem;
    opacity: 0.9;
    line-height: 1.6;
  }
`;

export const ProjectsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: -100px auto 4rem;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProjectCard = styled(motion.div)`
  height: 280px;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(0,0,0,0.2);
  }
`;

export const ProjectImage = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: contain; 
  object-position: top; 
  background-color: #e0e0e0; 
  transition: transform 0.5s ease;
  
  ${ProjectCard}:hover & {
    transform: scale(1.05);
  }
`;

export const ProjectOverlay = styled(motion.div)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 50%, transparent 100%);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: height 0.3s ease;
  height: 40%;
  
  ${ProjectCard}:hover & {
    height: 60%;
  }
`;

export const ProjectContent = styled.div`
  color: white;
  transform: translateY(20px);
  transition: transform 0.5s ease;

  ${ProjectCard}:hover & {
    transform: translateY(0);
  }

  h3 {
    font-size: 2rem;
    font-weight: 300;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1rem;
    opacity: 0.8;
    margin-bottom: 1.5rem;
  }
`;

export const portfolioData = [
  {
    id: 1,
    title: "El Templo by Zen Estétic",
    description: "Sitio web corporativo con tienda de experiencias",
    url: "https://eltemplobyzenestetic.es/el-templo"
  },
  {
    id: 2,
    title: "Zen Estétic",
    description: "Web Corporativa",
    url: "https://zenestetic.com/zen-estetic/"
  },
  {
    id: 3,
    title: "Proyecto Cocina Studio",
    description: "Web Corporativa de Cocinas",
    url: "https://proyectococina.com"
  },
  {
    id: 4,
    title: "Oh la la Aguadulce",
    description: "Web Corporativa",
    url: "https://ohlalaguadulce.es"
  },
  {
    id: 5,
    title: "Marisa Soler",
    description: "Web Corporativa Belleza",
    url: "https://marisasoler.com"
  },
  {
    id: 6,
    title: "Manuel Bernabé",
    description: "Web Corporativa",
    url: "https://manuelbernabe.com"
  },
  {
    id: 7,
    title: "Eva Fontcuberta",
    description: "Web Corporativa",
    url: "https://evafontcuberta.com"
  },
  {
    id: 8,
    title: "Petnaü",
    description: "Tienda de Mascotas",
    url: "https://petnau.es"
  },
  {
    id: 9,
    title: "Autoescuela Vicar",
    description: "Web Corporativa y Cursos Online",
    url: "https://autoescuelavicar.es"
  }
];